import styled, { ThemeProps } from 'styled-components';
import { colors } from './colors';
import fonts from './fonts';
import { Theme } from './types';

type TextType = 'primary' | 'secondary' | 'tertiary';

interface TextProps {
  type?: TextType;
}

export const textStyles = {
  h1: {
    fontFamily: fonts.semibold.family,
    fontWeight: fonts.semibold.weight,
    fontSize: '32px',
    lineHeight: '40px',
  },
  h2: {
    fontFamily: fonts.semibold.family,
    fontWeight: fonts.semibold.weight,
    fontSize: '24px',
    lineHeight: '32px',
  },
  h3: {
    fontFamily: fonts.semibold.family,
    fontWeight: fonts.semibold.weight,
    fontSize: '20px',
    lineHeight: '28px',
  },
  h4: {
    fontFamily: fonts.semibold.family,
    fontWeight: fonts.semibold.weight,
    fontSize: '18px',
    lineHeight: '24px',
  },
  h5: {
    fontFamily: fonts.semibold.family,
    fontWeight: fonts.semibold.weight,
    fontSize: '17px',
    lineHeight: '23px',
  },
  h6: {
    fontFamily: fonts.semibold.family,
    fontWeight: fonts.semibold.weight,
    fontSize: '15px',
    lineHeight: '21px',
  },
  p1: {
    fontFamily: fonts.regular.family,
    fontWeight: fonts.regular.weight,
    fontSize: '17px',
    lineHeight: '23px',
  },
  p2: {
    fontFamily: fonts.regular.family,
    fontWeight: fonts.regular.weight,
    fontSize: '15px',
    lineHeight: '21px',
  },
  p3: {
    fontFamily: fonts.regular.family,
    fontWeight: fonts.regular.weight,
    fontSize: '13px',
    lineHeight: '18px',
  },
  p4: {
    fontFamily: fonts.regular.family,
    fontWeight: fonts.regular.weight,
    fontSize: '11px',
    lineHeight: '16px',
  },
};

export const H1 = styled.h1<TextProps>`
  font-family: ${textStyles.h1.fontFamily};
  font-weight: ${textStyles.h1.fontWeight};
  font-size: ${textStyles.h1.fontSize};
  line-height: ${textStyles.h1.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const H2 = styled.h2<TextProps>`
  font-family: ${textStyles.h2.fontFamily};
  font-weight: ${textStyles.h2.fontWeight};
  font-size: ${textStyles.h2.fontSize};
  line-height: ${textStyles.h2.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const H3 = styled.h3<TextProps>`
  font-family: ${textStyles.h3.fontFamily};
  font-weight: ${textStyles.h3.fontWeight};
  font-size: ${textStyles.h3.fontSize};
  line-height: ${textStyles.h3.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const H5 = styled.h5<TextProps>`
  font-family: ${textStyles.h5.fontFamily};
  font-weight: ${textStyles.h5.fontWeight};
  font-size: ${textStyles.h5.fontSize};
  line-height: ${textStyles.h5.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const H6 = styled.h6<TextProps>`
  font-family: ${textStyles.h6.fontFamily};
  font-weight: ${textStyles.h6.fontWeight};
  font-size: ${textStyles.h6.fontSize};
  line-height: ${textStyles.h6.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const P1 = styled.p<TextProps>`
  font-family: ${textStyles.p1.fontFamily};
  font-weight: ${textStyles.p1.fontWeight};
  font-size: ${textStyles.p1.fontSize};
  line-height: ${textStyles.p1.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const P2 = styled.p<TextProps>`
  font-family: ${textStyles.p2.fontFamily};
  font-weight: ${textStyles.p2.fontWeight};
  font-size: ${textStyles.p2.fontSize};
  line-height: ${textStyles.p2.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const P3 = styled.p<TextProps>`
  font-family: ${textStyles.p3.fontFamily};
  font-weight: ${textStyles.p3.fontWeight};
  font-size: ${textStyles.p3.fontSize};
  line-height: ${textStyles.p3.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

export const P4 = styled.p<TextProps>`
  font-family: ${textStyles.p4.fontFamily};
  font-weight: ${textStyles.p4.fontWeight};
  font-size: ${textStyles.p4.fontSize};
  line-height: ${textStyles.p4.lineHeight};
  color: ${(props: TextProps & ThemeProps<Theme>) => getTextColor(props.theme, props.type)};
  margin: 0px;
`;

const getTextColor = (theme: Theme, type?: TextType) => {
  switch (type) {
    case 'secondary':
      return colors.grey;

    case 'tertiary':
      return theme.name === 'light' ? colors.grey : colors.white;

    default:
      return theme.primary;
  }
};
